import React from "react";
import { Route, Redirect } from "react-router-dom";
import * as SecureLS from "secure-ls";
import Layout from "../Layout/Layout";

function RutaLayoutLogged({ component: Component, ...rest }) {
  const ls = new SecureLS({
    encodingType: "des",
    isCompression: false,
    encryptionSecret: "admin-hyundai",
  });
  
  let auth = false;
  try {
    const data = ls.get("ask-hy");
    if (data && data.infoUsuario) {
      auth = data.infoUsuario.autenticado;
    }
  } catch (error) {
    console.error("Error leyendo LS", error);
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        auth === true ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}

export default RutaLayoutLogged;
